"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcHTMLSanitizer = void 0;
var EMBBED_TAG_HTML = /<[a-zA-Z0-9]+(?: [a-zA-Z]+="[^"]*")*>[^<>]*<\/[a-zA-Z]+>/g;
var VALID_FILE_NAME_PATTERN = /^[a-zA-Z]+$/;
var INVALID_CHARACTERS_PATTERN = /[^a-zA-Z0-9 ,._+-]/g;
var BcHTMLSanitizer = (function () {
    function BcHTMLSanitizer() {
    }
    BcHTMLSanitizer.prototype.sanitize = function (text) {
        return text.replace((EMBBED_TAG_HTML), '');
    };
    BcHTMLSanitizer.prototype.sanitizeFileName = function (fileName) {
        if (!VALID_FILE_NAME_PATTERN.test(fileName)) {
            return fileName.replace(INVALID_CHARACTERS_PATTERN, '');
        }
        return fileName;
    };
    return BcHTMLSanitizer;
}());
exports.BcHTMLSanitizer = BcHTMLSanitizer;
